import { Component, Inject, OnInit } from '@angular/core'
import { FormBuilder, FormGroup } from '@angular/forms'
import { Store } from '@ngrx/store'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ContractTemplate, UpdateContractTemplate } from '@tokeet-frontend/signature'
import { SaveForm } from '@tokeet-frontend/tv3-platform'

@Component({
  selector: 'app-template-message-dialog',
  templateUrl: './template-message-dialog.component.html',
  styleUrls: ['./template-message-dialog.component.scss'],
  host: { class: 'modal-content' },
})
export class TemplateMessageDialogComponent implements OnInit {
  form = this.fb.group({
    title: [],
    message: [],
  })

  constructor(
    private dialogRef: MatDialogRef<TemplateMessageDialogComponent>,
    private fb: FormBuilder,
    private store: Store<any>,
    @Inject(MAT_DIALOG_DATA) public data: { item: ContractTemplate }
  ) {}

  ngOnInit() {
    this.form.patchValue({
      title: this.data.item.title,
      message: this.data.item.message,
    })
  }

  @SaveForm()
  onSave(form: FormGroup) {
    const { title, message } = this.form.getRawValue()

    this.store.dispatch(
      UpdateContractTemplate({
        id: this.data.item.id,
        payload: { title, message },
        message: $localize`Message saved successfully.`,
      })
    )

    this.dialogRef.close()
  }

  close() {
    this.dialogRef.close()
  }
}
